import { memberApi } from '../config/axios-config';

export const getPcpDetailsService = (memberAccount,tenantId) => {
    return memberApi.get('/v3/my/PCPDetails', {
        headers: { 'member-account': memberAccount,'tenant-id':tenantId }
      });
};

export const updateProviderService = (memberAccountHeader,tenantId,params) => {
  return memberApi.post('/v3/my/changePCP', {
    providerNpi:params.providerNpi,
    providerName:params.providerName,
    providerFacilityName: params.providerFacilityName,
    providerSpeciality: params.providerSpeciality,
  }, {
    headers: { 'member-account': memberAccountHeader,'tenant-id':tenantId  }
  });
};

export const addProviderService = (memberAccountHeader,tenantId,params) => {
  return memberApi.post('/v3/my/changePCP', {
    providerNpi: params.providerNpi,
    providerName: params.providerName,
    providerFacilityName: params.providerFacilityName,
    providerSpeciality: params.providerSpeciality,
  }, {
    headers: { 'member-account': memberAccountHeader,'tenant-id':tenantId  }
  });
};

// export const getCoveragesService = (tenantId,memberAccountHeader) => {
//   return memberApi.post('https://healthcare.ascension.org/api/v2/providers/search', {
//     fromDate: '2020-01-01',
//     toDate: '2022-11-01',
//     eligibilityIndicator: true
//   }, {
//     headers: { 'member-account': memberAccountHeader,'tenant-id':tenantId  }
//   });
// };

// --header 'tenant-id: DCHP' \
// --header 'member-account: DCHPTXMD-770160643-1' \